<template>
  <pop-up
    button-text="Done"
    cancel
    class="top-fade-in"
    @add="$emit('add')"
    @close="$emit('close')"
  >
    <template #title>
      <strong>Your CNAME has been created</strong>
    </template>
    <div class="position-relative">
      <p>
        The next step is adding the NAME record to your domain's DNS records. Typically it takes just few minutes for DNS changes to take effect. <strong>Occasionally it can take up to 24 hours </strong> to fully propagate, depending on your DNS provider.
      </p>
      <input-field
        label="Domain name (for Host)"
        label-position="top"
        class="name"
      >
        <b-form-input
          v-model="domainName"
          disabled
          placeholder="Domain Name"
        />
      </input-field>
      <input-field
        label="CNAME (or Alias)"
        label-position="top"
        class="cname"
      >
        <b-form-input
          v-model="cname"
          disabled
          placeholder="Domain Name"
        />
      </input-field>
      <input-field
        label="TTL"
        label-position="top"
        class="ttl"
      >
        <div class="d-flex align-items-center">
          <b-form-input
            v-model="ttl"
            disabled
            class="custom-width"
            placeholder="TTL"
          />
          <strong>
            or your provider's default settings
          </strong>
        </div>
      </input-field>
    </div>
  </pop-up>
</template>

<script>
import PopUp from '@/components/popup/Pop-up.vue'

export default {
  name: 'ConfirmInstanceStatus',
  components: { PopUp },
  props: {
    domainName: {
      type: String,
      default: '',
    },
    cname: {
      type: String,
      default: '',
    },
    ttl: {
      type: [String, Number],
      default: null,
    },
  },
}
</script>

<style scoped>

.custom-width{
  width:70px;
  margin-right: 5px;
}

</style>
